module.exports = __webpack_public_path__ + "img/home-logo-big.8c8eb4e1.svg";